<script lang="ts" setup>
import { matomo } from './lib/helpers'

const lifecycleStore = useLifecycleStore()

const router = useRouter()
router.afterEach(to => {
  if (!lifecycleStore.initialized) return

  // Track in Matomo
  matomo('trackPageView')
  matomo('setCustomUrl', '/' + to.path.replace(/^\//, ''))
})
</script>

<template>
  <RouterView />
</template>
